var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSplashLine1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "746px",
    height: "242px",
    viewBox: "0 0 746 242",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.9997038%",
    cy: "49.876558%",
    fx: "49.9997038%",
    fy: "49.876558%",
    r: "112.543514%",
    gradientTransform: "translate(0.499997,0.498766),scale(0.324362,1.000000),translate(-0.499997,-0.498766)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC55E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    fill: "url(#radialGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M742.428993,229.522115 C717.066993,213.180115 687.981993,203.647115 658.104993,201.561115 C642.183993,200.451115 626.198993,202.311115 610.616993,205.664115 C595.033993,209.016115 579.921993,214.659115 564.461993,218.931115 C537.041993,226.503115 507.659993,227.284115 480.641993,217.573115 C454.821993,208.292115 433.602993,188.936115 417.079993,167.047115 C408.727993,155.978115 401.225993,144.021115 394.893993,131.626115 C388.561993,119.231115 383.441993,106.029115 377.998993,93.1044145 C372.632693,80.3621145 366.927493,67.6286145 359.227293,56.1527145 C351.273093,44.2952145 341.370493,33.6348145 330.298893,24.7959145 C306.283693,5.6218145 276.211683,-3.8242755 245.893993,1.4452345 C217.499293,6.3807945 192.611493,23.5078145 170.052993,40.9124145 C147.350993,58.4297145 125.457993,76.9749145 100.383993,90.9489145 C78.4059926,103.201115 52.0949926,113.467115 26.7669926,107.599115 C20.7059926,106.193115 14.9959926,103.938115 9.55399261,100.881115 C2.37899261,96.8559145 -4.04200739,108.084115 3.14099261,112.114115 C54.0259926,140.660115 111.514993,102.988115 151.708993,71.6707145 C174.707993,53.7500145 197.122293,34.0338145 223.776293,21.9291145 C250.481093,9.7984145 280.320113,9.9805145 306.283693,24.1367145 C330.870693,37.5425145 348.740293,59.7178145 360.629293,85.1242145 C366.601293,97.8838145 371.590693,111.090115 377.253593,123.993115 C382.903993,136.869115 389.557993,149.148115 397.223993,160.884115 C412.653993,184.495115 432.064993,206.362115 456.427993,220.483115 C480.789993,234.605115 510.395993,239.892115 538.625993,236.955115 C570.027993,233.690115 598.815993,219.256115 630.133993,215.387115 C659.637993,211.744115 690.205993,217.200115 717.083993,230.107115 C723.610993,233.243115 729.917993,236.817115 736.016993,240.750115 C742.958993,245.222115 749.341993,233.967115 742.428993,229.517115 L742.428993,229.522115 Z",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplashLine1);
export default __webpack_public_path__ + "static/media/splash_line1.c8ce177123cd70dd2615e34ad21d5722.svg";
export { ForwardRef as ReactComponent };